import {
  ContestCommentApi,
  ContestCommentContextTypeApi,
  MessageApi,
} from 'api-typings/contests/contests';
import { ContestComment } from './contest-comments.model';

export function transformContestComment(
  comment: ContestCommentApi,
): ContestComment {
  return {
    id: comment.id,
    contextType: comment.context_type,
    contextId: comment.context_id,
    comment: comment.comment,
    parentId: comment.parent_id,
    isPrivate: comment.is_private,
    fromUserId: comment.from_user_id,
    toUserId: comment.to_user_id,
    annotationId: comment.annotation_id,
    xCoordinate: comment.x_coordinate,
    yCoordinate: comment.y_coordinate,
    fileId: comment.file_id,
    timestamp: comment.timestamp ? comment.timestamp * 1000 : undefined,
    dateLastComment: comment.date_last_comment
      ? comment.date_last_comment * 1000
      : 0,
    isDeleted: false,
    repliesCount: comment.parent_id ? undefined : comment.replies_count, // A reply doesn't have replies_count
  };
}

export function transformMessageApiToContestComment(
  comment: MessageApi,
  senderId: number,
): ContestComment {
  // In MessageApi, `id` is an optional field
  const commentId = comment.id ? comment.id : 0;

  // We set the contextType and contextId by checking
  // values that exist in the result
  let contextType: ContestCommentContextTypeApi;
  let contextId: number;

  if (comment.annotation_id && comment.file_id) {
    contextType = ContestCommentContextTypeApi.ANNOTATION;
    contextId = comment.file_id;
  } else if (comment.entry_id) {
    contextType = ContestCommentContextTypeApi.ENTRY;
    contextId = comment.entry_id;
  } else {
    contextType = ContestCommentContextTypeApi.CONTEST;
    contextId = comment.contest_id;
  }

  const parentId = comment.parent_id ? comment.parent_id : undefined;

  return transformContestComment({
    id: commentId,
    context_type: contextType,
    context_id: contextId,
    comment: comment.comment,
    parent_id: parentId,
    is_private: comment.is_private,
    from_user_id: senderId,
    to_user_id: comment.to_user_id,
    annotation_id: comment.annotation_id,
    x_coordinate: comment.x_coordinate,
    y_coordinate: comment.y_coordinate,
    file_id: comment.file_id,
    timestamp: comment.timestamp,
    date_last_comment: comment.timestamp,
  });
}
